import { defaultTheme } from '../translate/util/constants'

export default function ThemeContainer({
    children,
    theme = defaultTheme,
}: {
    theme?: string
    children: React.ReactNode
}) {
    return (
        <div data-theme={theme} className="bg-base-300">
            <div className="flex h-dvh flex-col bg-base-100 md:mx-auto md:max-w-7xl">{children}</div>
        </div>
    )
}
